import $ from 'jquery';
import ProductColorSelect from '../../components/product-color-select';
import VideoModalButton from '../../components/video-modal-button';
$(() => {
    ProductColorSelect.init();
    VideoModalButton.init();
});
